import { PositionTuple } from '@1x2network/reel_set'

/**
 * Helper functions for working with PositionTuples
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

export function stringifyPositionTuple(position: PositionTuple): string {
    return `${position[0]},${position[1]}`
}

export function removeDuplicatePositionTuples(positionTuples: PositionTuple[]): PositionTuple[] {
    const uniquePositions = new Set<string>()
    const uniquePositionTuples: PositionTuple[] = []

    for (const position of positionTuples) {
        const positionString = stringifyPositionTuple(position)
        if (!uniquePositions.has(positionString)) {
            uniquePositions.add(positionString)
            uniquePositionTuples.push(position)
        }
    }

    return uniquePositionTuples
}

/**
 * Immutably sorts an array of PositionTuples first by row and then by reel
 * @param positionTuples Array of PositionTuples
 * @returns Sorted array of PositionTuples
 */
export function sortByRowThenReel(positionTuples: PositionTuple[]): PositionTuple[] {
    return [...positionTuples].sort((a, b) => {
        if (a[1] === b[1]) {
            return a[0] - b[0]
        }
        return a[1] - b[1]
    })
}
